/**
 * TODO: this should be in api contract / implement there
 */
export type OfferV1OfferPromotionPromotionType = '1+1' | 'freebie' | 'oneforone'

export enum OFFER_PROMOTION_TYPES {
  FREEBIE = 'freebie',
  ONE_FOR_ONE = 'oneforone',
  ONE_PLUS_ONE = '1+1',
}
